import { render } from "./loading3.vue?vue&type=template&id=ff3f1d08&scoped=true"
import script from "./loading3.vue?vue&type=script&lang=js"
export * from "./loading3.vue?vue&type=script&lang=js"

import "./loading3.vue?vue&type=style&index=0&id=ff3f1d08&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3f1d08"]])

export default __exports__